import type { Profile } from '@spot/shared';

type Interests = Profile['interests'];

/** Interests in common come first (T-1336); each part keeps the profile's own order. */
export function splitInterests(
	interests: Interests,
	mine: readonly string[],
): { shared: Interests; rest: Interests } {
	const own = new Set(mine);
	return {
		shared: interests.filter((interest) => own.has(interest.slug)),
		rest: interests.filter((interest) => !own.has(interest.slug)),
	};
}
